module.exports = __webpack_public_path__ + "media/images/flags/1x1/vat-f98056ca503c4f13e4c1389fc40b4f8b.svg";